import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController, AlertController } from 'ionic-angular';
import { Http } from '@angular/http';
import config from "../../../config/config";


/**
 * Generated class for the AgendamentoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-agendamento',
  templateUrl: 'ecagendamento.html',
})
export class ecAgendamentoPage {
  usuario: any;
  usuarioIdAuditoria;
  servicos: any;
  local:any;
  horario:any
  disponiveis = false;
  servicoescolhido:any;
  localescolhido:any;
  horariosescolhidos:any;
  resumo:any;
  diasEscolhido:any;
  grupo: any;
  dias: any;
  constructor(
    public navCtrl: NavController,
     public navParams: NavParams,
     public loadingCtrl: LoadingController,
     public _http: Http,
    private alertCtrl: AlertController,

     ) {
  }

  ionViewDidLoad() { 
    this.usuario = this.navParams.get("usuario");
    this.grupo = this.usuario.grupold;
      this.getServico()

    this.getLocal()
  }
  getServicosOperador() {
    this._http
    .get(config.urlAPI + "respectivo/servicoEspacocultural/"+this.usuario.id, {})
    // .get(config.urlAPI + "respectivo/servico/15663", {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      this.servicos = res;
    })
    .catch(error => { });
  }
  getServico() {
    this._http
      .get(config.urlAPI + "pesquisar/servicoCultural", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.servicos = res;

      })
      .catch(error => { });
  }
  getLocal() {
    this._http
      .get(config.urlAPI + "pesquisar/localCultural", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.local = res;
      })
      .catch(error => { });
  }

  salvar(){
    if (this.diasEscolhido == undefined||this.diasEscolhido == null  || this.localescolhido == undefined||this.localescolhido == null  ||this.servicoescolhido == undefined||this.servicoescolhido == null) {
      let alert = this.alertCtrl.create({
        title: "Por favor",
        subTitle: `Preencha todos os dados`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              // this.ionViewDidLoad()
            }
          }
        ]
      });
      alert.present();
      return true
    }
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    let env={
      user:this.usuario.id,
      agenda:this.diasEscolhido, 
      resumo:this.resumo
    }
    loading.dismiss()


    this.servicoescolhido=null;
    this.localescolhido=null;
    this.horariosescolhidos = null;
    this.diasEscolhido=null;
    this.horario = null;
    this.resumo=null;
    this.enviardados(env).then((r)=>{
      loading.dismiss()

    })
    return true

  }
  async enviardados(env){

    this._http
    .post(config.urlAPI + "cadastro/agendamentoEspacocultural",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {

        let alert = this.alertCtrl.create({
          title: "",
          subTitle: `${res.mnsg} `,
          buttons: [
            {
              text: "OK",
              handler: data => {
                // this.ionViewDidLoad()
              }
            }
          ],
          enableBackdropDismiss: false
        });
        alert.present();

      
      return res;
    })
    .catch(error => { 
      console.log(error)

      return error
    });
  }

  async getDiasDisponiveis(env) {
    this._http 
      .post(config.urlAPI + "pesquisar/dias/disponiveis",env, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.dias = res.item
        return res;
      })
      .catch(error => { 
        return error
      });
  }
  selcionados(env){
   
    if (this.localescolhido && this.servicoescolhido) {
      let buscar = {
        local:this.localescolhido,
        servico:this.servicoescolhido,
      }
      this.diasEscolhido = null
      let loading = this.loadingCtrl.create({
        content: "Aguarde"
      });
      loading.present();
      this.getDiasDisponiveis(buscar).then((r)=>{
        loading.dismiss();
      })      
    } 
  }

}



// WEBPACK FOOTER //
// ./src/pages/espaco-cultural/agendamento/ecagendamento.ts